import type { ReactNode } from "react";

export interface AlertProps {
  label: ReactNode;
  children: ReactNode;
  cta?: ReactNode;
  spacedBottom?: boolean;
  /** "warning" (default) is the neutral amber tone for informational
   *  banners (e.g. "Inheriting the platform catalog"). "error" is the
   *  stronger orange/risk-high tone for a failed load — a real problem,
   *  not just a heads-up. */
  tone?: "warning" | "error";
  "data-testid"?: string;
}

export function Alert({
  label,
  children,
  cta,
  spacedBottom,
  tone = "warning",
  "data-testid": testId,
}: AlertProps): JSX.Element {
  return (
    <div
      className={tone === "error" ? "alert alert--err" : "alert"}
      role="alert"
      data-spaced-bottom={spacedBottom ? "32" : undefined}
      data-testid={testId}
    >
      <div className="alert__lbl">{label}</div>
      <div className="alert__txt">{children}</div>
      {cta}
    </div>
  );
}
